import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ViewOptionsPanel from 'components/ViewOptionsPanel'
import { changeCameraAction } from 'actions/cameraActions'
import { zoomToSingleCameraAction } from 'actions/mapActions'
import { updateCurrentEntityAction } from 'actions/applicationActions'
import sortItems, { sortFloorPlans } from 'helpers/sortItems'
import { labelsSelector } from 'selectors/components'

const mapStateToProps = state => {
  const { cameras, currentEntity, map: { floorPlans } } = state

  return {
    cameras,
    currentEntity,
    floorPlans,
    labels: labelsSelector(state)
  }
}

const isSelected = (currentEntity, type, camera) => {
  return currentEntity && currentEntity.type === type && currentEntity.id === camera.id
}

class CameraList extends React.Component {
  state = { category: 'cameras' }

  cameraClickHandler = (camera, selected) => {
    const { changeCameraAction, updateCurrentEntityAction, zoomToSingleCameraAction, close } = this.props

    if (!camera.active) changeCameraAction(camera.id)
    else if (!selected) updateCurrentEntityAction({ id: camera.id, type: 'camera' })

    zoomToSingleCameraAction(camera)
    close()
  }

  labelClickHandler = (label, selected) => {
    const { updateCurrentEntityAction, close } = this.props

    if (!selected) {
      updateCurrentEntityAction({ id: label.id, type: 'label' })
      label.overlay.map.fitBounds(label.overlay.rectangle.getBounds())
    }

    close()
  }

  floorplanClickHandler = (floorplan, selected) => {
    const { updateCurrentEntityAction, close } = this.props

    if (!selected) {
      updateCurrentEntityAction({ id: floorplan.id, type: 'floorPlan' })
      floorplan.overlay.map.fitBounds(floorplan.overlay.getBounds())
    }

    close()
  }

  renderLenses = camera => {
    const { currentEntity, cameras, classes } = this.props
    const lenses = camera.lensIds.map(lensId => cameras.find(c => c.id === lensId))

    return (
      <div className={classes.lensWrapper}>
        { sortItems(lenses).map(lens => {
            const selected = isSelected(currentEntity, 'camera', lens)
            return (
              <div
                className={`${classes.lens} ${selected && classes.selected}`}
                onClick={_ => this.cameraClickHandler(lens, selected)}
                key={'lens' + lens.id}
              >
                <span>{lens.name} {selected ? ' (selected)' : ''}</span>
                <FontAwesomeIcon icon='arrow-right' className={classes.rightArrow} />
              </div>
          )})
        }
      </div>
    )
  }

  renderList = _ => {
    const { cameraClickHandler, labelClickHandler, floorplanClickHandler, renderLenses,
      state: { category }, props: { cameras, currentEntity, labels, floorPlans, classes } } = this

    if (category === 'cameras') {
      if (cameras.length == 0) return <span className={classes.noItems}><i>No cameras yet!</i></span>

      return (
        sortItems(cameras.filter(c => !c.imagerId)).map(function(camera, i) {
          const selected = isSelected(currentEntity, 'camera', camera)
          return (
            <div
              className={`${classes.cameraListItem} ${selected && classes.selected}`}
              key={'cameraList' + i}
            >
              <div onClick={cameraClickHandler.bind(this, camera, selected)} className={classes.camera}>
                <span>{camera.name} {selected ? ' (selected)' : ''}</span>
                <FontAwesomeIcon icon='arrow-right' className={classes.rightArrow} />
              </div>
              { camera.isMultiImager && renderLenses(camera) }
            </div>
          )
        })
      )
    } else if (category === 'labels') {
      if (labels.length == 0) return <span className={classes.noItems}><i>No labels yet!</i></span>

      return (
        sortItems(labels, 'text').map(function(label, i) {
          const selected = isSelected(currentEntity, 'label', label)
          return (
            <div
              className={`${classes.listItem} ${selected && classes.selected}`}
              onClick={labelClickHandler.bind(this, label, selected)}
              key={'labelList' + i}
            >
              <span>{label.text} {selected ? ' (selected)' : ''}</span>
              <FontAwesomeIcon icon='arrow-right' className={classes.rightArrow} />
            </div>
          )
        })
      )
    } else if (category === 'floorplans') {
      if (floorPlans.length == 0) return <span className={classes.noItems}><i>No floor plans yet!</i></span>

      return (
        sortFloorPlans(floorPlans).map(function(floorplan, i) {
          const selected = isSelected(currentEntity, 'floorPlan', floorplan)
          return (
            <div
              className={`${classes.listItem} ${selected && classes.selected}`}
              onClick={floorplanClickHandler.bind(this, floorplan, selected)}
              key={'floorplanList' + i}
            >
              <span>{ floorplan.name || `Floor Plan ${floorplan.id}` } {selected ? ' (selected)' : ''}</span>
              <FontAwesomeIcon icon='arrow-right' className={classes.rightArrow} />
            </div>
          )
        })
      )
    }

    return <ViewOptionsPanel isMobile />
  }

  render() {
    const { state: { category }, props: { classes } } = this

    return (
      <div className={classes.cameraList}>
        <div className={classes.list}>
          { this.renderList() }
        </div>
        <div className={classes.bottomWrapper}>
          <div onClick={_ => this.setState({ category: 'cameras' })} className={`${classes.bottomButton} ${category === 'cameras' && classes.buttonSelected}`}>
            <FontAwesomeIcon icon='video' className={classes.bottomIcon} />
            <p>Cameras</p>
          </div>
          <div onClick={_ => this.setState({ category: 'labels' })} className={`${classes.bottomButton} ${category === 'labels' && classes.buttonSelected}`}>
            <FontAwesomeIcon icon='comment' className={classes.bottomIcon} />
            <p>Labels</p>
          </div>
          <div onClick={_ => this.setState({ category: 'floorplans' })} className={`${classes.bottomButton} ${category === 'floorplans' && classes.buttonSelected}`}>
            <FontAwesomeIcon icon='building' className={classes.bottomIcon} />
            <p>Floor Plans</p>
          </div>
          <div onClick={_ => this.setState({ category: 'viewOptions' })} className={`${classes.bottomButton} ${category === 'viewOptions' && classes.buttonSelected}`}>
            <FontAwesomeIcon icon='cog' className={classes.bottomIcon} />
            <p>Options</p>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { changeCameraAction, zoomToSingleCameraAction, updateCurrentEntityAction })(injectSheet(style)(CameraList))



// WEBPACK FOOTER //
// ./src/components/BottomBar/CameraList/index.js